import React from 'react';
import './Contact.css'; 

const MainSectionContact = () => (
  <section className="contact-main-section">
    <div className="contact-hero">
      <div className="contact-title-container">
        <h1>Kontakt</h1>
      </div>
    </div>
  </section>
);

export default MainSectionContact;